import { render, staticRenderFns } from "./ImageAppointmentTable.vue?vue&type=template&id=8b08e684&"
import script from "./ImageAppointmentTable.vue?vue&type=script&lang=js&"
export * from "./ImageAppointmentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports